import { render, staticRenderFns } from "./EditAccountPage.vue?vue&type=template&id=393979ac&scoped=true&"
import script from "./EditAccountPage.vue?vue&type=script&lang=js&"
export * from "./EditAccountPage.vue?vue&type=script&lang=js&"
import style0 from "./EditAccountPage.vue?vue&type=style&index=0&id=393979ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393979ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardText,VFlex,VTextField})
